class CustomSelect extends HTMLElement {
  constructor() {
    super();

    this.selectElement = this.querySelector('select');

    this.a = document.createElement('DIV');
    this.a.setAttribute('class', this.selectElement.options[this.selectElement.selectedIndex].classList);
    this.a.classList.add('select-selected');
    this.a.innerHTML = this.selectElement.options[this.selectElement.selectedIndex].innerHTML;
    this.appendChild(this.a);

    this.b = document.createElement('DIV');
    this.b.setAttribute('class', 'select-items select-hide');

    this.selectElement.querySelectorAll('option').forEach(option => {
      this.c = document.createElement('DIV');
      this.c.setAttribute('class', option.classList);
      this.c.innerHTML = option.innerHTML;
      if (option.selected) this.c.classList.add('same-as-selected')
      this.c.addEventListener('click', event => {
          var targetElement = event.currentTarget;
          var s = targetElement.parentNode.parentNode.querySelector('select');
          var h = targetElement.parentNode.previousSibling;

          s.querySelectorAll('option').forEach((option, i) => {
            if (option.innerHTML == targetElement.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = targetElement.innerHTML;
              h.classList = targetElement.classList;
              h.classList.add('select-selected');
              targetElement.parentNode.querySelectorAll('.same-as-selected').forEach(el => {
                el.classList.remove('same-as-selected');
              });
              targetElement.classList.add('same-as-selected');
            }
          })

          h.click();

          const e = new Event('change');
          targetElement.closest('product-card').dispatchEvent(e);
      });
      this.b.appendChild(this.c);

      this.appendChild(this.b);
    });

    this.a.addEventListener('click', (event) => {
      event.stopPropagation();
      var targetElement = event.currentTarget;
      this.closeAllSelect(targetElement);
      targetElement.nextSibling.classList.toggle('select-hide');
      targetElement.classList.toggle('select-arrow-active');
    });

    document.addEventListener('click', this.closeAllSelect);
  }

  closeAllSelect(element) {
    var arrNo = [];

    document.querySelectorAll('.select-selected').forEach((el, i) => {
      if (element == el) {
        arrNo.push(i);
      } else {
        el.classList.remove('select-arrow-active');
      }
    });

    document.querySelectorAll('.select-items').forEach((el, i) => {
      if (arrNo.indexOf(i)) {
        el.classList.add('select-hide');
      }
    });
  }
}

customElements.define('custom-select', CustomSelect);

class ProductBundle extends HTMLElement {
  constructor() {
    super();

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  updateBundle(bundleId) {
    if (this.dataset.bundleId != bundleId) return;

    const currentBundleSize = this.dataset.bundleSize;
    var cartBundleItemsLength = 0;
    this.cart.querySelectorAll(`[data-bundle-id="${ bundleId }"]`).forEach(el => {
      cartBundleItemsLength += parseInt(el.querySelector('input.quantity__input').value);
    });
    
    if (currentBundleSize - cartBundleItemsLength <= 0) {
      this.querySelector('.information').innerHTML = 'Your bundle is ready!';
    } else {
      this.querySelector('.information').innerHTML = `Your bundle needs ${ currentBundleSize - cartBundleItemsLength } more item(s)!`;
    }
  }
}

customElements.define('product-bundle', ProductBundle);

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('submit', this.onSubmit);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateVariantInput() {
    const productForm = this.querySelector(`#product-form-${this.dataset.section}-${this.dataset.product}`);
    const input = productForm.querySelector('input[name="id"]');
    input.value = this.currentVariant.id;
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = this.querySelector('button[name="add"]');
    const addButtonText = addButton.querySelector('& > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  renderProductInfo() {
    const addButton = this.querySelector('button[name="add"]');
    if (!addButton) return;

    const addButtonPrice = addButton.querySelector('.product__item-prices');

    if (!this.currentVariant.available) {
      this.toggleAddButton(true, window.variantStrings.soldOut);
    } else {
      this.toggleAddButton(false, window.variantStrings.addToCart);
    }

    if (this.currentVariant.compare_at_price) {
      addButtonPrice.classList.add('has_compare_at_price');
      addButtonPrice.querySelector('.product__item-compare_at_price').innerHTML = '$' + (this.currentVariant.compare_at_price / 100);
    } else {
      addButtonPrice.classList.remove('has_compare_at_price');
      addButtonPrice.querySelector('.product__item-compare_at_price').innerHTML = '';
    }

    addButtonPrice.querySelector('.product__item-price').innerHTML = '$' + (this.currentVariant.price / 100);
  }

  updateMedia() {
    const images = this.querySelector('.product__image');

    images.querySelector(`.primary_product__image.active`).classList.remove('active');
    images.querySelector(`.primary_product__image[data-variants*="${ this.currentVariant.id }"]`).classList.add('active');
  }

  onSubmit() {
    document.querySelector('.product_bundle__container .information').innerHTML = `Your bundle needs ${ 3 } more item(s)!`;
  }
}

customElements.define('product-card', ProductCard);

class VariantRadios_Extended extends VariantRadios {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input[data-product-variant-option]')).find((radio) => radio.checked)?.value;
    });

    this.options.forEach((option, index) => {
      if (option) {
        this.querySelector(`[data-option-index="${ index + 1 }"] [data-option-value]`).innerHTML = option;
      }
    });
  }

  onVariantChange() {
    this.oldColorOption = this.currentVariant?.option1 || null;

    super.onVariantChange();

    this.currentProduct = this.getProductData();
    this.currentColorOption = this.currentVariant?.option1;
    

    if (this.currentColorOption !== this.oldColorOption) {
      this.mediaGallery = document.querySelector('media-gallery');
      this.mediaGalleryContainer = document.querySelector('media-gallery .media_gallery__container');

      const desktopGallery = document.querySelector("#GallerySlider_Desktop");
      const desktopThumbnailGallery = document.querySelector("#GalleryThumbnails_Desktop");
      const desktopSelectedVariantImage = document.querySelector(`#GallerySlider_Desktop .product-media-container[data-image-label="${this.currentColorOption}"]`);
      const desktopSelectedVariantContainer = document.querySelector("#GallerySlider_Desktop .selected-variant-container");

      if (!(desktopGallery && desktopGallery.classList.contains("simple"))) {
        if (desktopGallery) desktopGallery.classList.add("variant-selected");
        if (desktopThumbnailGallery) desktopThumbnailGallery.classList.add("variant-selected");

        if (desktopSelectedVariantImage && desktopSelectedVariantContainer) {
          const selectedVariantImageDuplicate = desktopSelectedVariantImage.cloneNode(true);
          const productMediaContainer = desktopSelectedVariantContainer.querySelector(".product-media-container");

          desktopSelectedVariantContainer.classList.remove("d-none");

          if (productMediaContainer) {
            productMediaContainer.remove();
            desktopSelectedVariantContainer.prepend(selectedVariantImageDuplicate);
          }
        }

        const mobileSelectedVariantImage = document.querySelector(`#GallerySlider_Mobile .product-media-container[data-image-label="${this.currentColorOption}"]`);
        const mobileSelectedVariantContainer = document.querySelector("#GallerySlider_Mobile .selected-variant-container");

        if (mobileSelectedVariantImage && mobileSelectedVariantContainer) {
          const mobileSelectedVariantImageDuplicate = mobileSelectedVariantImage.cloneNode(true);
          const mobileProductMediaContainer = mobileSelectedVariantContainer.querySelector(".product-media-container");

          mobileSelectedVariantContainer.classList.remove("d-none");

          if (mobileProductMediaContainer) {
            mobileProductMediaContainer.remove();
            mobileSelectedVariantContainer.prepend(mobileSelectedVariantImageDuplicate);
          }
        }

        const thumnailsSelectedVariantImage = document.querySelector(`#GalleryThumbnails_Desktop .product-media-container[data-image-label="${this.currentColorOption}"]`);
        const thumnailsSelectedVariantContainer = document.querySelector("#GalleryThumbnails_Desktop .selected-variant-container");

        if (thumnailsSelectedVariantImage && thumnailsSelectedVariantContainer) {
          const thumbnailsSelectedVariantImageDuplicate = thumnailsSelectedVariantImage.cloneNode(true);
          const thumbnailsProductMediaContainer = thumnailsSelectedVariantContainer.querySelector(".product-media-container");

          thumnailsSelectedVariantContainer.classList.remove("d-none");

          if (thumbnailsProductMediaContainer) {
            thumbnailsProductMediaContainer.remove();
            thumnailsSelectedVariantContainer.prepend(thumbnailsSelectedVariantImageDuplicate);
          }
        }

        const firstSwiperPaginationDot = document.querySelector("#GallerySlider_Mobile .swiper-pagination-bullet");
        const swiperPreviousButton = document.querySelector("#GalleryThumbnails_Desktop .swiper-button-prev__custom");

        const gallerySliderMobile = document.querySelector("#GallerySlider_Mobile .swiper");
        const galleryThumbnailsDesktop = document.querySelector("#GalleryThumbnails_Desktop .swiper");
        const GallerySlider_Desktop = document.querySelector("#GallerySlider_Desktop .swiper");
        const galleryThumbnailsDesktopPrev = document.querySelector("GalleryThumbnails_Desktop .swiper-button-prev__custom");
        const galleryThumbnailsDesktopNext = document.querySelector("GalleryThumbnails_Desktop .swiper-button-next__custom");

//         if (window.matchMedia("(max-width: 767px)").matches) {
//           const gallerySliderMobileSwiper = new Swiper(gallerySliderMobile, {
//             slidesPerView: 1.3,
//             spaceBetween: 0,
//             preventClicks: false,
//             preventClicksPropagation: false,
//             pagination: {
//               el: this.elements.gallerySliderMobilePagination,
//               clickable: true,
//               dynamicBullets: true,
//               dynamicMainBullets: 6
//             }
//           });
//         } else if (window.matchMedia("(min-width: 768px)").matches) {
//           const galleryThumbnailsDesktopSwiper = new Swiper(galleryThumbnailsDesktop, {
//             slidesPerView: galleryThumbnailsDesktop.parentElement.classList.contains('simple') ? 6 : 3,
//             spaceBetween: 10,
//             direction: 'vertical',
//             allowTouchMove: false,
//             preventClicks: false,
//             preventClicksPropagation: false,
//             navigation: {
//               nextEl: galleryThumbnailsDesktopPrev,
//               prevEl: galleryThumbnailsDesktopPrev
//             }
//           });
// 
//           const gallerySliderDesktopSwiper = new Swiper(GallerySlider_Desktop, {
//             slidesPerView: GallerySlider_Desktop.parentElement.classList.contains('simple') ? 1 : 2,
//             spaceBetween: 20,
//             direction: GallerySlider_Desktop.parentElement.classList.contains('simple') ? 'horizontal': 'vertical',
//             allowTouchMove: false,
//             preventClicks: false,
//             preventClicksPropagation: false,
//             thumbs: {
//               swiper: galleryThumbnailsDesktopSwiper
//             }
//           });
//         }

        if (firstSwiperPaginationDot) firstSwiperPaginationDot.click();

        if (swiperPreviousButton) {
          for (let i = 0; i < 10; i += 1) {
            swiperPreviousButton.click();
          }
        }
      }

      // this.mediaGalleryContainer.classList.add('loading');

      // fetch(`/products/${ this.currentProduct.handle }?variant=${ this.currentVariant.id }&sections=${ this.getSectionsToRender().map(section => section.id).join(',') }`)
      //   .then((response) => response.json())
      //   .then((response) => {
      //     console.log({response});
      //     debugger;
      //     this.renderContents(response)
      //   });
    }

    this.currentVariant.options.forEach((option, index) => {
      this.querySelector(`[data-option-index="${ index + 1 }"] [data-option-value]`).innerHTML = option;
    });

    if (this.currentVariant.available) {
      document.querySelector('product-info').classList.remove('is-out-of-stock');
      this.querySelector('[data-option-oos]').classList.add('visually-hidden');
    } else {
      document.querySelector('product-info').classList.add('is-out-of-stock');
      this.querySelector('[data-option-oos]').classList.remove('visually-hidden');
    }

  }

  updateVariantStatuses() {
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    var optionInputs, previousOptionSelected, availableOptionInputsValue;


    if (this.querySelectorAll('[data-product-variant-option]:checked')[0] && this.querySelectorAll('[data-product-variant-option]:checked')[1]) {
      // COLOR
      const selectedOptionOneVariants = this.variantData.filter(
        (variant) => this.querySelectorAll('[data-product-variant-option]:checked')[0].value === variant.option1
      );
  
      optionInputs = [...inputWrappers[1].querySelectorAll('input[data-product-variant-option][type="radio"], option')];
      previousOptionSelected = inputWrappers[0].querySelector('[data-product-variant-option]:checked').value;
      availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant.option1 === previousOptionSelected)
        .map((variantOption) => variantOption.option2)
      ;
    
      this.setInputAvailability(optionInputs, availableOptionInputsValue);

      // SIZE
      const selectedOptionTwoVariants = this.variantData.filter(
        (variant) => this.querySelectorAll('[data-product-variant-option]:checked')[1].value === variant.option2
      );
  
      optionInputs = [...inputWrappers[0].querySelectorAll('input[data-product-variant-option][type="radio"], option')];
      previousOptionSelected = inputWrappers[1].querySelector('[data-product-variant-option]:checked').value;
      availableOptionInputsValue = selectedOptionTwoVariants
        .filter((variant) => variant.available && variant.option2 === previousOptionSelected)
        .map((variantOption) => variantOption.option1)
      ;
      
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    }
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState[section.id], section.selector);
    });

    this.mediaGallery.initSliders();

    setTimeout(() => {
      const currentColor = document.querySelector('.product-form__input[data-option-name="color"] [data-option-value]').innerHTML;
      const desktopGalleryImage = document.querySelectorAll("#GallerySlider_Desktop .product-media-container");
      const mobileGalleryImage = document.querySelectorAll("#GallerySlider_Mobile .product-media-container");

      if (desktopGalleryImage[0]) {
        desktopGalleryImage[0].dataset.imageLabel = `${currentColor}`;
      }

      if (mobileGalleryImage[0]) {
        mobileGalleryImage[0].dataset.imageLabel = `${currentColor}`;
      }
    }, 200);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'product-media-gallery',
        selector: 'media-gallery'
      }
    ];
  }

  getProductData() {
    this.productData = this.productData || JSON.parse(document.querySelector('[type="application/ld+json"][data-product-info]').textContent);
    return this.productData;
  }
}

customElements.define('variant-radios-extended', VariantRadios_Extended);
